import React from 'react';
import './projects.css';
import Reveal from '../Reveal/Reveal';
import { projects } from '../../data/profile';

function Projects() {
  return (
    <section className="section" id="projects">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-eyebrow">Projects</span>
          <h2 className="section-title">Selected work</h2>
          <p className="section-sub">
            Platforms and pipelines I have designed and delivered for banking,
            telecom and enterprise clients.
          </p>
        </Reveal>

        <div className="projects-grid">
          {projects.map(({ name, subtitle, description, tags }, index) => (
            <Reveal key={name} className="card project-card" delay={index * 60}>
              <div className="project-card-head">
                <h3 className="project-name">{name}</h3>
                <p className="project-subtitle">{subtitle}</p>
              </div>
              <p className="project-description">{description}</p>
              <ul className="project-tags">
                {tags.map((tag) => (
                  <li key={tag} className="chip">
                    {tag}
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
